import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22variable%22:%22--font-heading%22,%22src%22:[{%22path%22:%22./Oswald-Light.ttf%22,%22weight%22:%22300%22},{%22path%22:%22./Oswald-Regular.ttf%22,%22weight%22:%22400%22},{%22path%22:%22./Oswald-Bold.ttf%22,%22weight%22:%22700%22}]}],%22variableName%22:%22heading%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'heading', 'heading Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
